import clickOutside from "../helpers/click-outside";

const dropdowns = document.querySelectorAll(".c-nav-dropdown");

dropdowns.forEach(dropdown => {
    dropdown.addEventListener("click", (e) => {
        const menu = dropdown.querySelector(".c-nav-dropdown__menu");
        if (menu) {
            // show menu
            menu.classList.add("c-nav-dropdown__menu--open");
            // hide menu on click away
            clickOutside(".c-nav-dropdown", () => {
                menu.classList.remove("c-nav-dropdown__menu--open");
            });
        }
    });
});